export interface BannerOptions {
  id?: string;
  showDismissButton: boolean;
  dismissOnRouteChange: boolean;
}

export const defaultOptions: BannerOptions = {
  showDismissButton: true,
  dismissOnRouteChange: true,
};
